import {useEffect, useState, useRef, LegacyRef, useCallback, FormEvent} from 'react';
import { DanceItem } from './DanceItem';
import VideoComponent from './VideoComponent';
import  ReactPlayer from 'react-player';
import { useNavigate, useParams } from 'react-router-dom';
import axios, {  } from 'axios';
import config from '../Config';
import { BlobUploadInfoDto } from '../Dto/BlobUploadInfoDto';
import { BlobServiceClient, StorageSharedKeyCredential } from '@azure/storage-blob';
import moment from 'moment'

/*interface IPage_EditProps {
  danceItem: DanceItem
}*/



const Page_Edit = (/*props:IPage_EditProps*/) => {
  
  let { id } = useParams();

  const playerRef = useRef<ReactPlayer>(null);
  const startTimeRef = useRef<number>(0);

  const isReady = useRef(false);

  const [videoUrl, setVideoUrl] = useState<string>("");

  const [selectedFile, setSelectedFile] = useState<File|null >(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);  
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true); 

  const [danceItem, setDanceItem] = useState<DanceItem|null>(null);
 
 

  useEffect(() => {
        const abortController = new AbortController();
        
        if (id === undefined || id === null)
        {
          let item = new DanceItem();
          item.id = -1;
          item.date = new Date();
          item.source = '';
          item.name = `Figure ${item.date.toLocaleDateString()}`;
          item.description = '';
          setDanceItem(item);
        }
        else
        {
            getDanceItemAsync(abortController);
        }
        setIsLoading(false);
        
        return () => {
            abortController.abort();
          };
      }, [id]);

   const getDanceItemAsync = async (abortController:AbortController)  => {
        try {

            var result = await axios.get<DanceItem>(config.backEndApi + `/api/GetDanceItem?id=${id}`);
            setDanceItem(result.data);
        }
        catch(e) {
          console.log(e);
        }
    }

  const onReady = useCallback(() => {
    if (playerRef.current ===null){
      return;
    }
    if (!isReady.current) {
      playerRef.current.seekTo(startTimeRef.current, 'seconds');
      isReady.current = true;
    }
  }, [isReady]);



  /*const handleVideoClicked = (id:number, startTimeInSeconds:number)=> {
    
    var item = items.find(i => i.id == id);
    if (item === undefined) {
      console.log("That's unexpexted");
      return;
  }
    setSelectedId(id);
    startTimeRef.current = startTimeInSeconds;
    //console.log(startTimeRef.current)
    isReady.current = false;
    setVideoUrl(item.videoUrl)

  }
    */

  const handleUploadClicked = async () => {
        // first get the sas token for the blob
    if (!selectedFile) {
      setUploadStatus('Please select a file first');
      return;
    }
    if (!selectedFile.name.toLowerCase().endsWith('.mp4')) {
      setUploadStatus('Please select an mp4 file');
      return;
    }
    if (danceItem!.id < 0 ) {
      setUploadStatus('For now save first');
      return;
    }

    /*if (!accountName || !accountKey || !containerName) {
      setUploadStatus('Azure Storage configuration is missing');
      return;
    }*/

    setIsUploading(true);
    setUploadStatus('Uploading...');
    setUploadProgress(0);

     try {

      var result = await axios.get<BlobUploadInfoDto>(config.backEndApi + `/api/GetUploadSasToken?fileName=${selectedFile.name}`/*, axiosRequestConfig*/);

      if (result.status !== 200) {
        //console.log("Error getting upload info");
        setUploadStatus(`Error getting upload info`);
        return;
      }

      const blobServiceClient = new BlobServiceClient(`https://${result.data.storageAccountName}.blob.core.windows.net?${result.data.sasToken}`
    );

    // Get container and blob clients
    const containerClient = blobServiceClient.getContainerClient(result.data.container);
    const blockBlobClient = containerClient.getBlockBlobClient(result.data.blobName);

      // Upload file with progress tracking
      const uploadResponse = await blockBlobClient.uploadData(selectedFile, {
        onProgress: (progress) => {
          const percentCompleted = Math.round((progress.loadedBytes / selectedFile.size) * 100);
          setUploadProgress(percentCompleted);
        },
        blobHTTPHeaders: {
          blobContentType: selectedFile.type || 'application/octet-stream'
        }
      });

      

      setUploadStatus('Upload successful!');
      console.log('Upload response:', uploadResponse);
      let newDanceItem = {...danceItem, videoUrl:`${result.data.blobName}`} as DanceItem;
      setDanceItem(newDanceItem)
      await axios.post<DanceItem>(config.backEndApi + `/api/UpdateDanceItem`, newDanceItem);
      

    } catch (error) {
      console.error('Upload error:', error);
      setUploadStatus(`Upload failed: ${error}`);
    } finally {
      setIsUploading(false);
    }

  }
  const handleCancelClicked = async () => {
        navigate('/'); 
    }

  const handleSaveClicked = async () => {
    try {
         
      if (danceItem!.id < 0) {
        var newItem = await axios.post<DanceItem>(config.backEndApi + `/api/CreateDanceItem`, danceItem);
        setDanceItem(newItem.data);
      }
      else {
        await axios.post<DanceItem>(config.backEndApi + `/api/UpdateDanceItem`, danceItem);
      }
    }catch(error) {
            console.log(error);
  }

        
    }
    

  const handleFileChange = (event:any) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadStatus('');
      setUploadProgress(0);
    }
  };

   const resetUpload = () => {
    setSelectedFile(null);
    setUploadProgress(0);
    setUploadStatus('');
  };

  const onSourceChanged = (event:FormEvent<HTMLInputElement>) => {
        setDanceItem({...danceItem, source:event.currentTarget.value} as DanceItem)
    }
  const onNameChanged = (event:FormEvent<HTMLInputElement>) => {
        setDanceItem({...danceItem, name:event.currentTarget.value} as DanceItem)
  }

  const onDescriptionChanged = (event:FormEvent<HTMLTextAreaElement>) => {
        setDanceItem({...danceItem, description:event.currentTarget.value} as DanceItem)
  }

  const onVideoUrlChanged = (event:FormEvent<HTMLInputElement>) => {
    setDanceItem({...danceItem, videoUrl:event.currentTarget.value} as DanceItem)
  }

  const onDateChanged = (event:FormEvent<HTMLInputElement>) => {
    const newDate = new Date(event.currentTarget.value);
    if (!isNaN(newDate.getTime())) {
      setDanceItem({...danceItem, date:newDate} as DanceItem)
    }
  }

  const onStartTimeInSecondsChanged = (event:FormEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.currentTarget.value);
    if (!isNaN(newValue)) {
      setDanceItem({...danceItem, startTimeInSeconds:newValue} as DanceItem)
    }
  }
  
    

    if (isLoading)
    {
      return <>Loading...</>
    }

    return(
        <>
          {danceItem?.videoUrlForDisplay != null && <div className="">
                <VideoComponent url={danceItem!.videoUrlForDisplay} startTimeInSeconds={0} />
          </div>
}
          <br></br>
          <div>Source/Teacher(s)</div>
          <input className='w-full rounded border' value={danceItem?.source} onChange={onSourceChanged}/>
          <div>Name/Title</div>
          <input className='w-full rounded border' value={danceItem?.name} onChange={onNameChanged}/>
          <div>Description</div>
          <textarea className='w-full rounded border' value={danceItem?.description} onChange={onDescriptionChanged}/>
          <div>Date</div>
          <input className='w-full rounded border' value={danceItem?.date == null ? '' : moment(danceItem?.date).format('MM/DD/YYYY')} onChange={onDateChanged}/>
          <div>VideoStarttime (s)</div>
          <input className='w-full rounded border' value={danceItem?.startTimeInSeconds} onChange={onStartTimeInSecondsChanged}/>
          <div>Video</div>
          <input className='w-full rounded border' value={danceItem?.videoUrl} onChange={onVideoUrlChanged} disabled={(danceItem == null || danceItem.isUploadedVideo === true)}/>
          <div>
          <input className='rounded border'
            type="file"
            id="fileInput"
            onChange={handleFileChange}
            disabled={isUploading}
            accept='video/mp4'
          />
            
          </div>

             {selectedFile && (
          <div className="file-info">
            <p><strong>File Name:</strong> {selectedFile.name}</p>
            <p><strong>File Size:</strong> {(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
            <p><strong>File Type:</strong> {selectedFile.type || 'Unknown'}</p>
          </div>
        )}

        {selectedFile && !isUploading && (
          <div className="upload-actions">
            <button className="bg-blue-300 text-white font-bold py-2 px-4 rounded" onClick={handleUploadClicked}>
              Upload
            </button>
            <button className="bg-blue-300 text-white font-bold py-2 px-4 rounded" onClick={resetUpload} >
              Reset
            </button>
          </div>
        )}

        {isUploading && (
          <div className="progress-container">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <span className="progress-text">{uploadProgress}%</span>
          </div>
        )}

        {uploadStatus && (
          <div className={`status-message ${uploadStatus.includes('failed') ? 'error' : 'success'}`}>
            {uploadStatus}
          </div>
        )}
          <br></br>

          
          <button className="bg-blue-300 text-white font-bold py-2 px-4 rounded" onClick={handleSaveClicked}>Save</button>
          <button className="bg-blue-300 text-white font-bold py-2 px-4 rounded" onClick={handleCancelClicked}>Cancel</button>
        </>
    );
}

export default Page_Edit;